// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Mui-select-select {\n  background-color: #fff !important; }\n\n.MuiSelect-select {\n  font-size: 12px !important;\n  padding-left: 5px !important; }\n\n.MuiInput-underline:before {\n  border-bottom: 2px solid #8d96b2 !important; }\n", ""]);
// Exports
module.exports = exports;
